import determineErrorMessage from 'bl/response/determineErrorMessage.bl';
import POS_READER_STATUS from 'constants/pos/posReaderStatus.const';
import noNilArray from 'utils/arrays/noNilArray.util';
import fromBeToBody from 'utils/converters/backend/fromBeToBody.util';
import logger from 'utils/logger.util';

const L = logger('determinePosReaderId');

const fromOldSingleToPosReaderInfo = (json) => {
  const readerStatus = json?.reader_status ?? json?.readerStatus;

  const isOrdered = POS_READER_STATUS.ordered === readerStatus;
  const isMissing = POS_READER_STATUS.noReader === readerStatus;
  const isOnline = POS_READER_STATUS.online === readerStatus;
  const isNotOnline = !isOnline;

  return { readerId: json?.reader, readerStatus, isOnline, isNotOnline, isMissing, isOrdered };
};

const fromNewMultipleToPosReaderInfos = noNilArray;

const determinePosReaderId = async (options) => {
  const { beFindReader, salonId } = options ?? {};

  const findResult = await beFindReader({ salonId });
  L.debug('()', 'findResult:', findResult);

  const json = fromBeToBody(findResult);

  const result = Array.isArray(json) ? fromNewMultipleToPosReaderInfos(json) : fromOldSingleToPosReaderInfo(json);
  result.message = determineErrorMessage(findResult);

  L.debug('()', 'result:', result);
  return result;
};

// noinspection JSUnusedGlobalSymbols
export default determinePosReaderId;
